import React, { Fragment, useState } from 'react';
import { Nav, NavItem, NavLink, Button } from 'reactstrap';
import { Link } from 'react-router-dom';
import makeUrl from '../../lib/makeUrl';
import FlightsDropdown from '../../components/TopBar/FlightsDropdown';

export default function SlidingMenu({ onLogin, onSignup, isLoggedIn }) {
  const [visibility, setVisibility] = useState(false);

  const show = () => setVisibility(true);
  const hide = () => setVisibility(false);

  return (
    <Fragment>
      <MenuButton onClick={show} />
      <Menu onClose={hide} visibility={visibility} onLogin={onLogin} onSignup={onSignup} isLoggedIn={isLoggedIn} />
    </Fragment>
  );
};

function MenuButton({ onClick }) {
  return (
    <Button className="d-block d-lg-none toggle-btn" onClick={onClick}>
      <span className="navbar-toggler-icon"></span>
    </Button>
  );
};

function Menu({ onClose, visibility, onLogin, onSignup, isLoggedIn }) {
  const className = visibility ? "show" : "hide";
  const { goToGuideListings, goToTreks, goToLodge, goToTransportation, goToBlog } = makeUrl;

  return (
    <div id="flyoutMenu" className={className}>
      <Nav navbar className="ml-auto navlist">
        <Link to={goToTreks}>
          <NavItem>Tours</NavItem>
        </Link>
        <FlightsDropdown homepage />
        <Link to={goToLodge}>
          <NavItem>Lodges</NavItem>
        </Link>
        <a href={goToGuideListings}>
          <NavItem>Guides</NavItem>
        </a>
        <Link to={goToTransportation}>
          <NavItem>Transport</NavItem>
        </Link>
        <a href={goToBlog}>
          <NavItem>Blog</NavItem>
        </a>

        {!isLoggedIn && (
          <Fragment>
            <NavItem>
              <NavLink className="btn btn-sm" onClick={onLogin}>Log In</NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className="btn btn-sm btn-outline-light"
                onClick={onSignup}
              >Sign Up</NavLink>
            </NavItem>
          </Fragment>
        )}
      </Nav>
      <Button className="d-block d-lg-none toggle-btn" onClick={onClose}>
        <span className="icon icon-hg-cross"></span>
      </Button>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/screens/Landing/SlidingMenu.jsx